
import eventSdk from './services/event-proxy.js';
import { KAFKA_TOPICS } from './constants.js';
import { faro } from '@grafana/faro-web-sdk';
export default function AppRoutes( experiences ) {
    const routes = [];

    // add all the routes from the experiences
    experiences.forEach( experience => {
        if ( experience.routes ) {
            experience.routes.forEach( route => {
                routes.push( {
                    ...route,
                    pattern: `${ experience.path || '' }${ route.pattern !== '/' ? route.pattern : '' }`,
                    bundles: experience.bundles,
                    contentClassName: experience.contentClassName,
                    stringAttributeBundles: experience.stringAttributeBundles
                } );
            } );
        }
    } );

    return routes;
}
export const getMiddleware = ( store, auth ) => {
    return [
        // Load Bundles
        async ( action, nextRoute, prevRoute ) => {

            if ( nextRoute.hash !== '' &&  nextRoute.hash.indexOf( 'sso' >= 0 ) ) {
                auth.removeUser();
                action.ok();
            }
            if ( nextRoute && nextRoute.pathname.charAt( nextRoute.pathname.length - 1 ) !== '/' ) {
                if ( nextRoute.search ) {
                    action.redirect( nextRoute.pathname + '/' + nextRoute.search );
                } else {
                    action.redirect( nextRoute.pathname + '/' );
                }
            } else if ( nextRoute && nextRoute.pathname === '/' ) {
                if ( nextRoute.search ) {
                    action.redirect( '/home/' + nextRoute.search );
                } else {
                    action.redirect( '/home/' );
                }
                action.ok();
            } else {
                const topicName = KAFKA_TOPICS.EXPERIENCE_NAVIGATION;
                const eventData = {
                    application: 'web-event-proxy',
                    sessionId: auth.state.session_id,
                    companyId: auth.state?.claims?.company_id,
                    sessionPersonId: auth.state?.claims?.person_id,
                    navigationLocation: 'Umbrella',
                    action: 'ROUTE_CHANGED',
                    currentPath: prevRoute.pathname,
                    targetPath: nextRoute.pathname
                };
                faro?.api?.pushEvent( 'ui-navigation', { ...eventData } );
                eventData.timestamp = Date.now();
                if ( auth && auth.state && auth.state.session_id ) {
                    try {
                        await eventSdk.sendEvent( eventData, topicName );
                    } catch {
                        action.ok();
                    }
                }
                action.ok();
            }
        }
    ];
};
